import { render } from "./SideBar.vue?vue&type=template&id=00466ca5"
import script from "./SideBar.vue?vue&type=script&lang=js"
export * from "./SideBar.vue?vue&type=script&lang=js"

import exportComponent from "/Users/nakarinjaiseengam/Works/STM/STM-POS/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__